import Swiper, { Autoplay, Navigation, EffectFade } from 'swiper';
Swiper.use([Autoplay, Navigation, EffectFade]);

window.addEventListener('DOMContentLoaded', function() {
	const sliders = document.querySelectorAll('.testimonials-slider__slider');

	if (sliders.length > 0) {
		sliders.forEach(element => {
			new Swiper(element, {
				autoplay: {
					delay: 5000,
				},
				autoHeight: element.getAttribute('data-autoheight'),
				disableOnInteraction: false,
				pauseOnMouseEnter: true,
				speed: 1500,
				slidesPerView: 1,
				loop: true,
				navigation: {
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				},
			});
		});

	}

	const sliderGallery = document.querySelector('.gallery-before-after__slider.swiper-container');

	if (sliderGallery) {
		new Swiper(sliderGallery, {
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
			autoHeight: true,
			centeredSlides: true,
			effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
			speed: 1000,
			slidesPerView: 1,
			loop: false,
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});
	}
});



// WEBPACK FOOTER //
// ./scripts/modules/_sliders.js